







import Vue from 'vue';
import { PageMode } from '@/main/utils/pageMode';

export default Vue.extend({
	name: 'NotFound',
	beforeCreate() {
		if (this.$route.meta && this.$route.meta.hasList) {
			let path = this.$route.fullPath;

			path[path.length - 1] !== '/' && (path += '/');

			this.$router.replace(`${path}${PageMode.LIST}`);
		}
	},
// 	methods: {
// 		isAccessDenied():boolean {
// 			console.log(this.$route.fullPath);
//         return  this.$route.fullPath.indexOf('accessdenied') > -1 ? true:false;
//     },
//   },
});
